import { useCallback, useEffect, useState, useRef } from "react";
import useHttp from "hooks/use-http";
import {
  getAllReportCardUserCom,
  geteducationalYearsRequest,
} from "api/requests";
import { useParams } from "react-router-dom";
import { Grid, Button } from "@mui/material";
import {
  StyledStack,
  StyledTitle,
  StyledTable,
  StyledTableBottom,
  StyledTr,
  StyledTh,
  StyledTd,
  StyledTableContainer,
  StyledMainReportCard,
} from "./ReportCard.style";
import CloseButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import ReactToPrint from "react-to-print";

export default function ReportCard() {
  const componentRef = useRef();
  const params = useParams();
  const { request, loading, setLoading } = useHttp();

  const [reportcard, setReportCard] = useState({
    data: [],
  });

  const getReportCards = async () => {
    setLoading(true);
    const res = await request({
      url: getAllReportCardUserCom,
      values: { exam_id: params.examId },
    });
    let transformedData = res?.data.map((items) => ({
      id: items.id,
      first_name: items?.student?.first_name ?? "-",
      last_name: items?.student?.last_name ?? "-",
      national_code: items?.student?.national_code ?? "-",
      date: items?.exam?.comprehensive_exam?.date?.string,
      level: items?.exam?.level ?? "-",
      branch: items?.exam?.branch ?? "-",
      number_of_questions: items?.exam?.number_of_questions ?? "-",
      correct: items?.correct ?? "-",
      incorrect: items?.incorrect ?? "-",
      not_answered: items?.not_answered ?? "-",
      is_present: items?.is_present ?? "-",
      total_rank: items?.rank ?? "-",
      exam_balance: items?.exam_balance ?? [],
    }));
    setReportCard({
      data: transformedData,
    });
    setLoading(false);
  };

  useEffect(() => {
    getReportCards();
  }, []);

  return (
    <DrawerCM title="کارنامه آزمون جامع" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <Grid container my={2}>
            <Grid item mt={3} xs={12}>
              <CloseButton />
            </Grid>

            <StyledStack>
              <StyledTitle>
                <div>{" کارنامه آزمون جامع"}</div>
                <ReactToPrint
                  trigger={() => <Button variant="contained">چاپ</Button>}
                  content={() => componentRef.current}
                />
              </StyledTitle>
              <div ref={componentRef}>
                {reportcard?.data
                  .filter((item) => item?.is_present)
                  .map((items, index) => (
                    <StyledMainReportCard
                      style={{
                        padding: "10px",
                        // borderBottom: "2px solid black",
                      }}
                      key={index}
                      className="PrintCard"
                    >
                      <Grid container>
                        <Grid item xs={10} mb={1}>
                          <Grid container>
                            <Grid item xs={6} mb={1}>
                              <span> نام و نام خانوادگی : </span>
                              <span>
                                {items?.first_name + " " + items?.last_name}
                              </span>
                            </Grid>
                            <Grid item xs={6} mb={1}>
                              <span> تاریخ آزمون : </span>
                              <span>{`${items?.date}`}</span>
                            </Grid>
                            <Grid item xs={6} mb={1}>
                              <span> پایه و رشته : </span>
                              <span>
                                {items?.level + " - " + items?.branch}
                              </span>
                            </Grid>
                            <Grid item xs={6} mb={2}>
                              <span> کد ملی : </span>
                              <span>{items?.national_code}</span>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <StyledTableContainer>
                        <StyledTable>
                          <thead style={{ background: "#efefef" }}>
                            <StyledTr>
                              <StyledTh rowSpan={2}>ردیف</StyledTh>
                              <StyledTh colSpan={5}>نمرات</StyledTh>
                              <StyledTh colSpan={4}>سوالات</StyledTh>
                            </StyledTr>
                            <StyledTr>
                              <StyledTh>نام درس</StyledTh>
                              <StyledTh>درصد</StyledTh>
                              <StyledTh>تراز</StyledTh>
                              <StyledTh>رتبه</StyledTh>
                              <StyledTh>تعداد پاسخ دهنده</StyledTh>
                              <StyledTh>کل</StyledTh>
                              <StyledTh>درست</StyledTh>
                              <StyledTh>غلط</StyledTh>
                              <StyledTh>نزده</StyledTh>
                            </StyledTr>
                          </thead>
                          <tbody>
                            {items?.exam_balance.map((item, index) => (
                              <StyledTr key={index}>
                                <StyledTd>{index + 1}</StyledTd>
                                <StyledTd style={{ textAlign: "right" }}>
                                  {item?.answer_courses?.course?.title ?? "-"}
                                </StyledTd>
                                <StyledTd>
                                  {item?.answer_courses?.percentage ?? "-"}
                                </StyledTd>
                                <StyledTd>{item?.balance ?? "-"}</StyledTd>
                                <StyledTd>{item.rank ?? "-"}</StyledTd>
                                <StyledTd>{item.total_count ?? "-"}</StyledTd>
                                <StyledTd>
                                  {item?.answer_courses?.not_answered +
                                    item?.answer_courses?.answered ?? "-"}
                                </StyledTd>
                                <StyledTd>
                                  {item?.answer_courses?.correct ?? "-"}
                                </StyledTd>
                                <StyledTd>
                                  {item?.answer_courses?.incorrect ?? "-"}
                                </StyledTd>
                                <StyledTd>
                                  {item?.answer_courses?.not_answered ?? "-"}
                                </StyledTd>
                              </StyledTr>
                            ))}
                          </tbody>
                        </StyledTable>
                      </StyledTableContainer>
                      <StyledTableContainer>
                        <StyledTableBottom style={{ marginTop: "2px" }}>
                          <thead style={{ background: "#efefef" }}>
                            <StyledTr>
                              <StyledTh colSpan={6}>وضعیت کلی آزمون</StyledTh>
                            </StyledTr>
                            <StyledTr>
                              <StyledTh></StyledTh>
                              <StyledTh>تعداد سوالات</StyledTh>
                              <StyledTh>درست</StyledTh>
                              <StyledTh>غلط</StyledTh>
                              <StyledTh>نزده</StyledTh>
                              <StyledTh>رتبه کل</StyledTh>
                            </StyledTr>
                          </thead>
                          <tbody>
                            <StyledTr>
                              <StyledTd>وضعیت کلی</StyledTd>
                              <StyledTd>{items?.number_of_questions}</StyledTd>
                              <StyledTd>{items?.correct}</StyledTd>
                              <StyledTd>{items?.incorrect}</StyledTd>
                              <StyledTd>{items?.not_answered}</StyledTd>
                              <StyledTd>{items?.total_rank}</StyledTd>
                            </StyledTr>
                          </tbody>
                        </StyledTableBottom>
                      </StyledTableContainer>
                    </StyledMainReportCard>
                  ))}
              </div>
            </StyledStack>
          </Grid>
        </>
      )}
    </DrawerCM>
  );
}
